<template>
    <div  style="height:600px;width:100%;" id="be_like_me">
        <StandardAlert v-if="type==='DONATION'" v-on:donation_done="donation_done" ref="standard_alert" :locked=false :id_given="'1'" :editable=false :data="donation_data" :setup="setup"></StandardAlert>
        <GoalAlert v-if="type==='GOAL'" v-on:donation_done="donation_done" ref="standard_alert" :locked=false :id_given="'1'" :editable=false :data="donation_data" :setup="setup"></GoalAlert>

    </div>
</template>

<script>
    import StandardAlert from "../components/StandardAlert";
    import GoalAlert from "../components/GoalAlert";
    export default {
        name: "DonationWidget",
        components: {StandardAlert, GoalAlert},
        data() {
            return {

                queue:[],
                sid:null,
                setup:null,
                donation_data:{
                    AMOUNT:null,
                    MESSAGE:null,
                    SENDER_NAME:null
                },
                type:null
            }
        },
        mounted:function(){
            this.connect();


        },

        methods: {

            connect:function(){
                let id=this.$route.query.id;
                this.$socket.emit('donation_greeting', id);
            },

            handle_donation(data){
                this.donation_data.AMOUNT=data.AMOUNT;
                this.donation_data.MESSAGE=data.MESSAGE;
                this.donation_data.SENDER_NAME=data.NAME;
                this.setup.MIN_DONATION=parseInt(this.setup.MIN_DONATION);
                if(this.type==="DONATION"){
                    this.$refs.standard_alert.message();
                }
                else{
                    this.setup.MIN_DONATION+=parseInt(data.AMOUNT);
                }




            },
            donation_done(){
                let self=this;
                self.queue=self.queue.slice(1)

            },
            colorMe(amount){
                if(parseInt(amount)>499){
                    return "orange"
                }
                else if(parseInt(amount)>99){
                    return "purple"
                }
                else if(parseInt(amount)>49){
                    return "blue"
                }
                else if(parseInt(amount)>20){
                    return "green"
                }
                else{
                    return "#3f3f3f"
                }
            },


        },

        sockets: {

            bump(){
              console.log("BUMPED!");
                this.$socket.emit('bump', this.sid);
            },
            update(id){
                if(id===this.$route.query.id){
                    this.connect();
                }


            },

            donation(data_in){
                let data={
                    AMOUNT:data_in[0],
                    MESSAGE:data_in[1],
                    NAME:data_in[2]
                };
                if(this.queue.length===0){
                    this.handle_donation(data);
                    this.queue.push(data);

                }
                else{
                    this.queue.push(data);

                }

            },
            connected(data) {
                try{
                    let data_p=JSON.parse(data);
                    this.sid=data_p.SID;
                    this.type=data_p.TYPE;
                    this.setup=JSON.parse(data_p.SETUP)

                }
                catch{
                    // Oh snap

                }
            }},
        watch:{
            queue:function(newQ,oldQ){
                if(newQ.length<oldQ.length && newQ.length>0){
                    this.handle_donation(this.queue[0])
                }
            }
        }
    }
</script>

<style>
    iframe{
        width:100% !important;
        height:100% !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }


</style>
